import { Tooltip } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { BiBold } from "react-icons/bi";
import { twMerge } from "tailwind-merge";
import { useTextEditorContext } from "../../hooks/useTextEditorContext";
import { activeButtonStyle, buttonStyle } from "./TextEditorMenuStyle";

export interface TextEditorMenuButtonBoldProps {
  className?: string;
  children?: React.ReactNode;
}

export const TextEditorMenuButtonBold = ({ className, children }: TextEditorMenuButtonBoldProps) => {
  const { t } = useTranslation("textEditor");
  const { editor, disabled } = useTextEditorContext();

  const buttonClassName = editor && editor.isActive("bold") ? twMerge(buttonStyle, activeButtonStyle) : buttonStyle;

  return (
    <Tooltip content={t("buttons.bold")}>
      <button
        type="button"
        onClick={() => {
          if (editor) {
            editor.chain().focus().toggleBold().run();
          }
        }}
        className={twMerge(buttonClassName, className)}
        disabled={disabled}
      >
        {children ?? <BiBold className="h-6 w-6" />}
      </button>
    </Tooltip>
  );
};
